import { Box, IconButton, MenuItem, TextField } from "@mui/material";
import { useState, useEffect } from "react";
import { GLTFResult } from "../../api/threed";
import { GLBAnimationType, GLBMotionMapper, Model, MotionMapperType } from "../../models/Model";
import { MLEvents } from "../common/ModelLoader";
import { ModelRenderer } from "../ModelRenderer";
import * as THREE from "three";
import { PropValueLine } from "../common/PropValueLine";
import { PlayCircle, StopCircle } from "@mui/icons-material";
import { GLBAnimator } from "../../visuals/GLBAnimator";

export function GLTFAnimationPropsPanel({ mr }: { mr: ModelRenderer }) {
  const [selectedModel, setSelectedModel] = useState<Model | null>(null);
  const [animations, setAnimations] = useState<string[]>([]);
  const [mapper, setMapper] = useState<GLBMotionMapper | null>(null);
  const [playingAnimation, setPlayingAnimation] = useState('');
  useEffect(() => {
    if (!mr) return;
    const handleModelLoaded = (m?: THREE.Object3D) => {
      setSelectedModel(mr.loader.model);
      const model = mr.loader.model;
      if (m?.userData.gltf) {
        const gltf = m.userData.gltf as GLTFResult;
        setAnimations(gltf.animations.map((anim) => anim.name));
        if (model.motionMapper.type !== MotionMapperType.AnimatedGLB) {
          const mapper: GLBMotionMapper = {
            type: MotionMapperType.AnimatedGLB,
            animationMap: {}
          };
          model.motionMapper = mapper;
        }
        const motionMapper = model.motionMapper as GLBMotionMapper;
        gltf.animations.forEach((anim) => {
          if (motionMapper.animationMap[anim.name]) return;
          motionMapper.animationMap[anim.name] = GLBAnimationType.Unknown;
        });
        setMapper(motionMapper);
        mr.animator = new GLBAnimator(mr.loader);
      }
    };
    handleModelLoaded(mr.loader.modelObj);
    mr.loader.onEvent(MLEvents.ModelLoaded, handleModelLoaded);
    return () => {
      mr.loader.removeListener(MLEvents.ModelLoaded, handleModelLoaded);
    };
  }, [mr]);

  if (!selectedModel || !mapper) {
    return <Box>Loading...</Box>;
  }

  return (
    <Box>
      {animations.map((anim) => <PropValueLine key={anim} labelWidth={150} label={anim} value={
        <div key={anim}>
          <TextField
            variant="standard"
            size='small'
            style={{ width: '150px', marginRight: '10px' }}
            value={mapper.animationMap[anim] || GLBAnimationType.Unknown}
            onChange={(e) => {
              if (mapper) {
                mapper.animationMap[anim] = e.target.value as GLBAnimationType;
                setMapper({ ...mapper });
              }
            }}
            select
          >
            {Object.values(GLBAnimationType).map((type) => (
              <MenuItem key={type} value={type}>{type}</MenuItem>
            ))}
          </TextField>
          <IconButton
            size="small"
            onClick={() => {
              const a = mr.animator as GLBAnimator;
              if (playingAnimation === anim) {
                setPlayingAnimation('');
                a.stop();
              } else {
                setPlayingAnimation(anim);
                a.startAnimation(anim);
              }
            }}
            >
            {playingAnimation === anim ? <StopCircle /> : <PlayCircle />}
            </IconButton>
        </div>
      } />)}
    </Box>
  );
}